import { render, staticRenderFns } from "./taskTag.vue?vue&type=template&id=6bb34514&"
import script from "./taskTag.vue?vue&type=script&lang=js&"
export * from "./taskTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports